/* Black Week 2026 campaign layer (kit3): countdowns, slide-out, Klaviyo signup, low-stock line.
   Config comes from window.B26 (written in theme.liquid by build.py). */
(function () {
  var C = window.B26 || {};
  var root = document.documentElement;
  var t = function (s) { return Date.parse(s); };
  var VIP = C.phase === 'pvip' || C.phase === 'vip';
  /* BW26 (3/11): Black Week / Black Friday / Cyber Monday sign-up gives the code BW26 by mail, like VIPNIGHT in the VIP theme */
  var CODE = C.phase === 'bw' || C.phase === 'bf' || C.phase === 'cm';
  var JOINED_KEY = CODE ? 'b26-bw26' : 'b26-vip';
  function target(el) { return t(el.getAttribute('data-b26-end') || C.end); }
  function parts(ms) {
    ms = Math.max(0, ms);
    var s = Math.floor(ms / 1000);
    return [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-b26-end]').forEach(function (el) {
      var p = parts(target(el) - now);
      if (el.hasAttribute('data-b26-inline')) {
        var u = C.u || ['d', 't', 'm', 's'];
        el.textContent = p[0] + u[0] + ' ' + pad(p[1]) + u[1] + ' ' + pad(p[2]) + u[2];
        return;
      }
      var b = el.querySelectorAll('b');
      for (var i = 0; i < b.length && i < 4; i++) b[i].textContent = pad(p[i]);
    });
  }
  tick();
  setInterval(tick, 1000);


  /* Recolour safety net: any element still painted in the old brand teal/petrol gets the campaign colours.
     Runs after load and whenever the page changes (cart drawer refresh, lazy sections). */
  var TEAL = ['57,142,130', '58,142,130', '94,163,154', '70,182,172', '0,184,184', '56,142,130'];
  var PETROL = ['44,91,115', '43,92,115', '45,91,115', '30,49,106', '12,59,82', '13,59,82', '63,107,128', '69,111,132', '23,65,90', '57,112,142', '57,113,142', '102,146,165'];
  var ACC = getComputedStyle(root).getPropertyValue('--b-acc').trim(), DK = getComputedStyle(root).getPropertyValue('--b-dk').trim(), ON = getComputedStyle(root).getPropertyValue('--b-on').trim(), SOFT = getComputedStyle(root).getPropertyValue('--b-soft').trim();
  function rgb(v) { var m = v && v.match(/rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?\)/); return m && m[4] !== '0' ? m[1] + ',' + m[2] + ',' + m[3] : null; }
  function lum(c) { var p = c.split(',').map(Number); return 0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]; }
  function bgOf(e) { for (var a = e; a && a !== document.documentElement; a = a.parentElement) { var b = rgb(getComputedStyle(a).backgroundColor); if (b) return b; } return '255,255,255'; }
  function fix(e) {
    if (e.closest('[class*="b26-"],[class*="swatch"],[class*="color_links"],.payment-list,[class*="payment"]') || e.matches('img,video,iframe,picture,source')) return;
    var s = getComputedStyle(e), bg = rgb(s.backgroundColor), c = rgb(s.color), bc = rgb(s.borderTopColor), f = rgb(s.fill);
    var box = e.getBoundingClientRect(), small = box.width * box.height < 90000 && box.height < 140;
    var bi = s.backgroundImage;
    if (small && bi && bi !== 'none' && bi.indexOf('url(') < 0 && /(57, 142, 130|70, 182, 172|94, 163, 154|44, 91, 115|43, 92, 115)/.test(bi)) { e.style.setProperty('background-image', 'none', 'important'); if (!bg) bg = '57,142,130'; }
    if (small && bg && TEAL.indexOf(bg) > -1) { e.style.setProperty('background-color', ACC, 'important'); e.style.setProperty('color', ON, 'important'); return; }
    if (bg && TEAL.indexOf(bg) > -1) e.style.setProperty('background-color', DK, 'important');
    else if (bg && PETROL.indexOf(bg) > -1) e.style.setProperty('background-color', DK, 'important');
    else if (bg === '158,184,195') e.style.setProperty('background-color', SOFT, 'important');
    var dark = lum(bgOf(e)) < 110;
    if (c && (TEAL.indexOf(c) > -1 || PETROL.indexOf(c) > -1)) e.style.setProperty('color', dark ? ACC : DK, 'important');
    if (f && (TEAL.indexOf(f) > -1 || PETROL.indexOf(f) > -1)) e.style.setProperty('fill', dark ? ACC : DK, 'important');
    if (bc && parseFloat(s.borderTopWidth) > 0 && (TEAL.indexOf(bc) > -1 || PETROL.indexOf(bc) > -1)) e.style.setProperty('border-color', DK, 'important');
  }
  function scan(rootEl) { if (rootEl.nodeType !== 1) return; fix(rootEl); var all = rootEl.querySelectorAll('*'); for (var i = 0; i < all.length; i++) fix(all[i]); }
  var pending = [], rq;
  function queue(n) { pending.push(n); clearTimeout(rq); rq = setTimeout(function () { var list = pending; pending = []; list.forEach(function (x) { if (x.isConnected) scan(x); }); }, 200); }
  function initial() { queue(document.body); }
  if (document.readyState === 'complete') initial(); else window.addEventListener('load', initial);
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      var tg = m[i].target;
      if (tg.closest && tg.closest('[class*="b26-"],[data-b26-end]')) continue;
      for (var k = 0; k < m[i].addedNodes.length; k++) if (m[i].addedNodes[k].nodeType === 1) queue(m[i].addedNodes[k]);
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* Klaviyo signup (client API, public company id only) */
  function subscribe(email) {
    var props = CODE ? { BW26_code: true, BW26_signup_phase: C.phase } : { VIP_BW26: true };
    var body = { data: { type: 'subscription', attributes: { custom_source: (CODE ? 'BW26 code ' : 'BW26 VIP ') + (C.store || ''), profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: C.listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body),
      signal: (window.AbortSignal && AbortSignal.timeout) ? AbortSignal.timeout(12000) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-b26-form]');
    if (!f) return;
    e.preventDefault();
    if (f.getAttribute('data-state') === 'busy') return;
    var input = f.querySelector('input[type=email]');
    var wrap = f.parentNode;
    var ok = wrap.querySelector('.b26-ok'), err = wrap.querySelector('.b26-err');
    if (!input) return;
    if (!input.value || !/.+@.+\..+/.test(input.value)) { if (err) err.hidden = false; input.focus(); return; }
    if (!C.companyId || !C.listId) { if (err) err.hidden = false; return; }
    f.setAttribute('data-state', 'busy');
    subscribe(input.value.trim()).then(function () {
      try { localStorage.setItem(JOINED_KEY, '1'); } catch (x) {}
      f.hidden = true; if (err) err.hidden = true; if (ok) ok.hidden = false;
      document.querySelectorAll('[data-b26-form]').forEach(function (o) { if (o !== f) { o.hidden = true; var k = o.parentNode.querySelector('.b26-ok'); if (k) k.hidden = false; } });
      /* signed up inside the slide-out: leave the thank-you on screen for a moment before it closes */
      if (so && so.contains(f)) setTimeout(function () { closeSo(true); }, 8000); else closeSo(true);
    }).catch(function () { f.removeAttribute('data-state'); if (ok && !ok.hidden) return; if (err) err.hidden = false; });
  });

  /* "Bliv VIP" links -> /#vip (Jonas 21/10: no separate VIP page). On the homepage: scroll to the hero signup + focus, without reloading */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="/#vip"]'), h = document.getElementById('vip');
    if (!a || !h) return;
    e.preventDefault();
    (h.querySelector('.b26-pn') || h).scrollIntoView({ behavior: 'smooth', block: 'start' });
    var f = h.querySelector('[data-b26-form] input');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 500);
    if (history.replaceState) history.replaceState(null, '', '#vip');
  });

  /* #vip in the URL (Klaviyo invite mails): scroll to the hero signup and focus the email field */
  if (location.hash === '#vip') {
    window.addEventListener('load', function () {
      var f = document.querySelector('.b26-hero [data-b26-form] input');
      var h = document.getElementById('vip');
      if (!h) return;
      var p = h.querySelector('.b26-pn') || h, moved = false, n = 0;
      /* keep re-aiming for ~30 s: late layout shifts and cookie banners (scroll lock until closed) otherwise leave the signup off screen; stops as soon as the visitor scrolls */
      ['wheel', 'touchmove', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { moved = true; }, { once: true, passive: true }); });
      (function aim() {
        if (moved) return;
        if (Math.abs(p.getBoundingClientRect().top) > 40) p.scrollIntoView({ block: 'start' });
        if (++n < 60) setTimeout(aim, 500);
      })();
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
    });
  }

  /* Slide-out: after 10 s, once per visitor until closed; closed -> small tab */
  var so = document.querySelector('.b26-so'), tab = document.querySelector('.b26-tab');
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (x) { return null; } }
  var soTimer, hideTimer;
  function openSo() { if (!so) return; clearTimeout(hideTimer); if (store('b26-so-' + C.phase) === 'done') return; so.hidden = false; requestAnimationFrame(function () { so.classList.add('is-open'); }); if (tab) tab.hidden = true; }
  function closeSo(done) {
    if (!so) return;
    so.classList.remove('is-open');
    clearTimeout(soTimer); clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { so.hidden = true; }, 500);
    store('b26-so-' + C.phase, done ? 'done' : 'closed');
    if (tab && !done) tab.hidden = false;
  }
  /* never open on top of a cookie/consent window: wait until it is closed, then 3 s more */
  function cookieOpen() {
    var els = document.querySelectorAll('#coiOverlay, #CybotCookiebotDialog, #gdpr-blocking-page-overlay, #gdpr-cookie-consent, .cky-consent-container, .cky-modal, #pandectes-banner, .cc-window, [id*="cookie-banner"], [class*="cookie-banner"]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i], cs = getComputedStyle(e), r = e.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0.05 && r.width > 0 && r.height > 0) return true;
    }
    return false;
  }
  function openWhenFree() {
    if (!cookieOpen()) return openSo();
    var t = setInterval(function () { if (!cookieOpen()) { clearInterval(t); soTimer = setTimeout(openSo, 3000); } }, 800);
  }
  if (so) {
    var state = store('b26-so-' + C.phase);
    var joined = (VIP || CODE) && store(JOINED_KEY) === '1';
    if (!joined && state !== 'done') {
      if (state === 'closed') { if (tab) tab.hidden = false; }
      else soTimer = setTimeout(openWhenFree, 10000);
    }
    var x = so.querySelector('.b26-so__x'); if (x) x.addEventListener('click', function () { closeSo(false); });
    if (tab) tab.addEventListener('click', openSo);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && so.classList.contains('is-open')) closeSo(false); });
  }

  /* BW26 (3/11): <home>/#bw26 (the ads' landing) and every link to /#bw26 open the code sign-up slide-out right away,
     the way /#vip opened the VIP sign-up. Never on top of a cookie window: then it opens the moment that closes. */
  function openCode() {
    if (!so) { var h = document.querySelector('.b26-hero [data-b26-form] input'); if (h) { h.scrollIntoView({ block: 'center' }); h.focus({ preventScroll: true }); } return; }
    clearTimeout(soTimer);
    var go = function () {
      clearTimeout(hideTimer); so.hidden = false;
      requestAnimationFrame(function () { so.classList.add('is-open'); });
      if (tab) tab.hidden = true;
      var i = so.querySelector('[data-b26-form]:not([hidden]) input');
      if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 450);
    };
    if (!cookieOpen()) return go();
    var w = setInterval(function () { if (!cookieOpen()) { clearInterval(w); go(); } }, 400);
  }
  if (CODE) {
    if (location.hash === '#bw26') {
      if (document.readyState === 'complete') openCode(); else window.addEventListener('load', function () { setTimeout(openCode, 300); });
    }
    window.addEventListener('hashchange', function () { if (location.hash === '#bw26') openCode(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="/#bw26"], a[href="#bw26"], a[href$="/#bw26"]');
      if (!a) return;
      e.preventDefault();
      openCode();
    });
  }

  /* Low stock bar on product pages: real inventory per variant, shown under 20 */
  var sb = document.querySelector('[data-b26-stock]');
  if (sb && sb.querySelector('span')) {
    var inv = {};
    try { inv = JSON.parse(sb.getAttribute('data-b26-stock')); } catch (x) {}
    var show = function (id) {
      var v = inv[id];
      if (!v || v.q <= 0 || v.q >= 20) { sb.hidden = true; return; }
      sb.hidden = false;
      var noSize = !v.s || v.s === 'Default Title';
      sb.querySelector('span').textContent = (noSize ? sb.getAttribute('data-tpl-n') : sb.getAttribute('data-tpl')).replace('{n}', v.q).replace('{s}', v.s);
    };
    show(sb.getAttribute('data-current'));
    document.addEventListener('variant:changed', function (e) { if (e.detail && e.detail.variant) show(String(e.detail.variant.id)); });
  }
})();

/* Keep the slide-out clear of the A+ sticky ATC: measure how much of the viewport bottom the sticky really covers
   (its own height plus any offset, e.g. the preview bar) and expose it as --b26-sticky for bw26.css. */
(function () {
  var st = document.getElementById('aplus-sticky');
  if (!st) return;
  var raf = 0;
  function upd() {
    raf = 0;
    var v = st.classList.contains('is-visible') ? Math.max(0, Math.round(window.innerHeight - st.getBoundingClientRect().top)) : 0;
    document.documentElement.style.setProperty('--b26-sticky', v + 'px');
  }
  function q() { if (!raf) raf = requestAnimationFrame(upd); }
  window.addEventListener('scroll', q, { passive: true });
  window.addEventListener('resize', q);
  st.addEventListener('transitionend', q);
  new MutationObserver(q).observe(st, { attributes: true, attributeFilter: ['class', 'style'] });
  q();
})();
